// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-call-tile-secret,
.voice-call-chip-secret {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: rgba(12, 24, 28, 0.92);
  color: #72e5bd;
  border: 1px solid rgba(72, 214, 160, .38);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.voice-call-tile-secret {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 26px;
  height: 26px;
  z-index: 4;
}

.voice-call-tile-secret.with-kick-control {
  right: 38px;
}

.voice-call-tile-secret.with-mic-control {
  right: 70px;
}
.voice-call-tile-secret > span[aria-hidden],
.voice-call-chip-secret > span[aria-hidden] {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .04em;
}

.voice-call-chip-secret {
  width: 27px;
  height: 27px;
  margin-left: 4px;
}

.voice-call-secret-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #0e171d;
  border-radius: 999px;
  background: #d9b36a;
  color: #172019;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  box-sizing: border-box;
  pointer-events: none;
}

.secret-message-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #2b4546;
  border-radius: 10px;
  background: #11191f;
  color: #e7f1ed;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.42);
}

.voice-call-video-tile.secret-message-open,
.voice-call-chip.secret-message-open {
  overflow: visible;
  z-index: 12;
}

.voice-call-chip.secret-message-open {
  position: relative;
}

/* The panel intentionally lives inside the selected tile/chip in the DOM.
   Video conversations stay inside the participant frame so a tall tile can
   never push the composer below the viewport. */
.secret-message-panel--anchored {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  width: min(380px, 92vw);
  max-height: min(500px, 66vh);
}

.voice-call-video-tile .secret-message-panel--anchored {
  top: 50%;
  right: 12px;
  width: min(380px, calc(100% - 24px));
  min-width: min(320px, calc(100% - 24px));
  max-height: calc(100% - 24px);
  transform: translateY(-50%);
}

.secret-message-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.secret-message-header div {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 3px;
}

.secret-message-header strong {
  font-size: 14px;
  letter-spacing: .01em;
}

.secret-message-header span {
  color: #a7f3d0;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.secret-message-header button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.secret-message-header button:hover,
.secret-message-header button:focus-visible {
  background: rgba(255, 255, 255, .1);
  outline: none;
}

.secret-message-history {
  min-height: 150px;
  overflow-y: auto;
  padding: 14px;
}

.secret-message-bubble {
  width: fit-content;
  max-width: 86%;
  margin: 6px 0;
  padding: 9px 12px;
  border-radius: 12px;
  overflow-wrap: anywhere;
  font-size: 15px;
}

.secret-message-bubble.mine {
  margin-left: auto;
  background: #123f34;
  border: 1px solid #277d62;
}

.secret-message-bubble.theirs {
  background: #202b32;
}

.secret-message-error {
  margin: 8px 14px;
  color: #d1d5db;
  font-size: 13px;
  color: #fca5a5;
}

.secret-message-verification {
  flex: 1;
  display: grid;
  place-items: center;
  min-height: 180px;
  padding: 24px;
}

.secret-message-verification button {
  min-width: 120px;
  min-height: 44px;
  border: 1px solid #34d399;
  border-radius: 9px;
  background: #145c49;
  color: #f1fff9;
  padding: 10px 18px;
  font-weight: 700;
  cursor: pointer;
}

.secret-message-verification button:hover,
.secret-message-verification button:focus-visible {
  background: #1b755e;
  outline: none;
}

.secret-message-request-sent {
  max-width: 320px;
  margin: 0;
  color: #a7f3d0;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
}

.secret-message-mobile-layer {
  position: fixed;
  inset: 0;
  z-index: 100500;
  display: flex;
  align-items: flex-end;
  padding: max(10px, env(safe-area-inset-top)) 10px max(10px, env(safe-area-inset-bottom));
  background: rgba(3, 7, 18, .72);
  overflow: auto;
  overscroll-behavior: contain;
}

.secret-message-panel--mobile-overlay {
  position: relative;
  inset: auto;
  width: 100%;
  max-width: none;
  max-height: calc(100dvh - max(20px, env(safe-area-inset-top)) - max(20px, env(safe-area-inset-bottom)));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px 14px 0 0;
  box-shadow: 0 -16px 48px rgba(0, 0, 0, .45);
}

.secret-message-mobile-layer--call-minimized {
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.secret-message-mobile-layer--call-minimized .secret-message-panel--mobile-overlay {
  width: min(520px, calc(100vw - 48px));
  max-height: min(680px, calc(100dvh - 48px));
  border-radius: 16px;
}

.secret-message-panel--mobile-overlay .secret-message-history {
  min-height: 120px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.secret-message-back-indicator {
  margin-right: 4px;
  font-weight: 800;
}

.secret-message-compose {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.secret-message-compose textarea {
  flex: 1;
  resize: none;
  border: 1px solid #3b5558;
  border-radius: 9px;
  background: #10181e;
  color: #e7f1ed;
  padding: 10px;
  font: inherit;
}

.secret-message-compose button {
  border: 0;
  border-radius: 9px;
  background: #1e8f6c;
  color: #f1fff9;
  padding: 0 16px;
  font-weight: 700;
  min-width: 70px;
  min-height: 44px;
}

.secret-message-compose button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 600px) {
  .secret-message-panel--anchored {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100vw - 16px);
    max-height: min(560px, calc(100vh - 100px));
  }

  .secret-message-bubble,
  .secret-message-compose textarea {
    font-size: 17px;
  }

  .secret-message-compose textarea {
    min-height: 58px;
  }
}

/* The direct-message sheet is intentionally modal on narrow desktops as well:
   video, room chat, and a device conversation must not compete in three
   compressed columns. */
@media (min-width: 601px) and (max-width: 1100px) {
  .secret-message-mobile-layer {
    align-items: center;
    justify-content: center;
    padding: 24px;
  }

  .secret-message-panel--mobile-overlay {
    width: min(520px, calc(100vw - 48px));
    max-height: min(680px, calc(100dvh - 48px));
    border-radius: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SecretMessagePanel.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;gDAEgD;AAChD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,oCAAoC;EACpC,wCAAwC;EACxC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EAIf,cAAc;AAHhB;;AAMA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,wFAAwF;EACxF,+BAA+B;EAC/B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,uGAAuG;EACvG,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,2CAA2C;EAC7C;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;wBAEwB;AACxB;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;EACrB;AACF","sourcesContent":[".voice-call-tile-secret,\n.voice-call-chip-secret {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(12, 24, 28, 0.92);\n  color: #72e5bd;\n  border: 1px solid rgba(72, 214, 160, .38);\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.voice-call-tile-secret {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  width: 26px;\n  height: 26px;\n  z-index: 4;\n}\n\n.voice-call-tile-secret.with-kick-control {\n  right: 38px;\n}\n\n.voice-call-tile-secret.with-mic-control {\n  right: 70px;\n}\n.voice-call-tile-secret > span[aria-hidden],\n.voice-call-chip-secret > span[aria-hidden] {\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: .04em;\n}\n\n.voice-call-chip-secret {\n  width: 27px;\n  height: 27px;\n  margin-left: 4px;\n}\n\n.voice-call-secret-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #0e171d;\n  border-radius: 999px;\n  background: #d9b36a;\n  color: #172019;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.secret-message-panel {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #2b4546;\n  border-radius: 10px;\n  background: #11191f;\n  color: #e7f1ed;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.42);\n}\n\n.voice-call-video-tile.secret-message-open,\n.voice-call-chip.secret-message-open {\n  overflow: visible;\n  z-index: 12;\n}\n\n.voice-call-chip.secret-message-open {\n  position: relative;\n}\n\n/* The panel intentionally lives inside the selected tile/chip in the DOM.\n   Video conversations stay inside the participant frame so a tall tile can\n   never push the composer below the viewport. */\n.secret-message-panel--anchored {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  width: min(380px, 92vw);\n  max-height: min(500px, 66vh);\n}\n\n.voice-call-video-tile .secret-message-panel--anchored {\n  top: 50%;\n  right: 12px;\n  width: min(380px, calc(100% - 24px));\n  min-width: min(320px, calc(100% - 24px));\n  max-height: calc(100% - 24px);\n  transform: translateY(-50%);\n}\n\n.secret-message-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 13px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.secret-message-header div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 3px;\n}\n\n.secret-message-header strong {\n  font-size: 14px;\n  letter-spacing: .01em;\n}\n\n.secret-message-header span {\n  color: #a7f3d0;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.secret-message-header button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.secret-message-header button:hover,\n.secret-message-header button:focus-visible {\n  background: rgba(255, 255, 255, .1);\n  outline: none;\n}\n\n.secret-message-history {\n  min-height: 150px;\n  overflow-y: auto;\n  padding: 14px;\n}\n\n.secret-message-bubble {\n  width: fit-content;\n  max-width: 86%;\n  margin: 6px 0;\n  padding: 9px 12px;\n  border-radius: 12px;\n  overflow-wrap: anywhere;\n  font-size: 15px;\n}\n\n.secret-message-bubble.mine {\n  margin-left: auto;\n  background: #123f34;\n  border: 1px solid #277d62;\n}\n\n.secret-message-bubble.theirs {\n  background: #202b32;\n}\n\n.secret-message-error {\n  margin: 8px 14px;\n  color: #d1d5db;\n  font-size: 13px;\n}\n\n.secret-message-error {\n  color: #fca5a5;\n}\n\n.secret-message-verification {\n  flex: 1;\n  display: grid;\n  place-items: center;\n  min-height: 180px;\n  padding: 24px;\n}\n\n.secret-message-verification button {\n  min-width: 120px;\n  min-height: 44px;\n  border: 1px solid #34d399;\n  border-radius: 9px;\n  background: #145c49;\n  color: #f1fff9;\n  padding: 10px 18px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.secret-message-verification button:hover,\n.secret-message-verification button:focus-visible {\n  background: #1b755e;\n  outline: none;\n}\n\n.secret-message-request-sent {\n  max-width: 320px;\n  margin: 0;\n  color: #a7f3d0;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: center;\n}\n\n.secret-message-mobile-layer {\n  position: fixed;\n  inset: 0;\n  z-index: 100500;\n  display: flex;\n  align-items: flex-end;\n  padding: max(10px, env(safe-area-inset-top)) 10px max(10px, env(safe-area-inset-bottom));\n  background: rgba(3, 7, 18, .72);\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.secret-message-panel--mobile-overlay {\n  position: relative;\n  inset: auto;\n  width: 100%;\n  max-width: none;\n  max-height: calc(100dvh - max(20px, env(safe-area-inset-top)) - max(20px, env(safe-area-inset-bottom)));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 14px 14px 0 0;\n  box-shadow: 0 -16px 48px rgba(0, 0, 0, .45);\n}\n\n.secret-message-mobile-layer--call-minimized {\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.secret-message-mobile-layer--call-minimized .secret-message-panel--mobile-overlay {\n  width: min(520px, calc(100vw - 48px));\n  max-height: min(680px, calc(100dvh - 48px));\n  border-radius: 16px;\n}\n\n.secret-message-panel--mobile-overlay .secret-message-history {\n  min-height: 120px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.secret-message-back-indicator {\n  margin-right: 4px;\n  font-weight: 800;\n}\n\n.secret-message-compose {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.secret-message-compose textarea {\n  flex: 1;\n  resize: none;\n  border: 1px solid #3b5558;\n  border-radius: 9px;\n  background: #10181e;\n  color: #e7f1ed;\n  padding: 10px;\n  font: inherit;\n}\n\n.secret-message-compose button {\n  border: 0;\n  border-radius: 9px;\n  background: #1e8f6c;\n  color: #f1fff9;\n  padding: 0 16px;\n  font-weight: 700;\n  min-width: 70px;\n  min-height: 44px;\n}\n\n.secret-message-compose button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n@media (max-width: 600px) {\n  .secret-message-panel--anchored {\n    right: auto;\n    left: 50%;\n    transform: translateX(-50%);\n    width: calc(100vw - 16px);\n    max-height: min(560px, calc(100vh - 100px));\n  }\n\n  .secret-message-bubble,\n  .secret-message-compose textarea {\n    font-size: 17px;\n  }\n\n  .secret-message-compose textarea {\n    min-height: 58px;\n  }\n}\n\n/* The direct-message sheet is intentionally modal on narrow desktops as well:\n   video, room chat, and a device conversation must not compete in three\n   compressed columns. */\n@media (min-width: 601px) and (max-width: 1100px) {\n  .secret-message-mobile-layer {\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n  }\n\n  .secret-message-panel--mobile-overlay {\n    width: min(520px, calc(100vw - 48px));\n    max-height: min(680px, calc(100dvh - 48px));\n    border-radius: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
